import axios from './BaseService';

const API_URL =
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL;
const ONBOARDING_URL = `${API_URL}/onboarding/`;

export async function getOnboardingStatus() {
    const response = await axios.get(`${ONBOARDING_URL}status`);
    return response.data; //{onboardedAt, completed, steps: [{id, done}]}
}

export async function completeOnboarding() {
    const response = await axios.post(`${ONBOARDING_URL}complete`);
    return response.data; //{onboardedAt}
}
